import { BaseEntity, HtmlDetailData } from "./base.model";
import { Question } from "./question.model";
import { Translations } from "./language.model";

export interface Survey extends BaseEntity {
  id: string;
  name: string;
  description?: HtmlDetailData;
  complete?: HtmlDetailData;
  couponComplete?: HtmlDetailData;
  questions: QuestionAction[];
  translations?: Translations;
}

export interface Condition {
  action: QuestionActionEnum;
  value: string | string[];
  question: Question;
}

export interface QuestionAction {
  question: Question;
  conditions?: Condition[];
}

export enum QuestionActionEnum {
  "equal" = "equal",
  "notEqual" = "notEqual",
  "contain" = "contain",
}
